import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { setStage, STAGE } from '../utils/clarity';

// Initialize GA4 only if the Measurement ID is provided in .env
const TRACKING_ID = import.meta.env.VITE_GA_ID;

/**
 * Route -> funnel stage, for the Clarity `stage` tag. The editor and upload
 * routes deliberately return nothing: their stage follows the JOB (uploading /
 * transcribing / editor / export), which TranscriptEditor and JobContext set.
 * Returning undefined leaves the existing tag alone rather than clobbering it.
 */
function stageForPath(pathname) {
  if (pathname === '/') return STAGE.landing;
  if (pathname.startsWith('/app/editor') || pathname.startsWith('/app/upload')) return undefined;
  if (pathname.startsWith('/app/billing') || pathname === '/success') return STAGE.billing;
  if (pathname.startsWith('/app')) return STAGE.dashboard;
  if (['/login', '/register', '/forgot-password'].includes(pathname)) return STAGE.auth;
  if (pathname.startsWith('/reset-password') || pathname.startsWith('/verify-email')) return STAGE.auth;
  return undefined;
}

if (TRACKING_ID) {
  ReactGA.initialize(TRACKING_ID);
}

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if initialized
    if (TRACKING_ID) {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
    // Clarity is independent of the GA id: the tag loads from index.html.
    setStage(stageForPath(location.pathname));
  }, [location]);

  return null; // This component doesn't render anything
};

export default Analytics;
